'use client'
import { useEffect, useRef, useState } from 'react'

import getStatus from '@/shared/hooks/useStatus'
import ThemeTable from '../../themeTable'
import BatterDataRow from './BatterDataRow'

type ScorecardTableTypes = {
  data: any
  fullSquad: any[]
  matchDetail: any
}

const ScorecardTable = ({ data, fullSquad, matchDetail }: ScorecardTableTypes) => {
  const { sStatusStr } = getStatus(matchDetail)
  const [expendId, setExpendId] = useState(null)
  const labels = [
    'Batter',
    <>
      <span className="hidden sm:inline" key={'runs'}>
        Runs
      </span>
      <span className="sm:hidden" key={'r'}>
        R
      </span>
    </>,
    <>
      <span className="hidden sm:inline" key={'balls'}>
        Balls
      </span>
      <span className="sm:hidden" key={'b'}>
        B
      </span>
    </>,
    'SR',
    '4s',
    '6s'
  ]
  const table = useRef({
    nRuns: 'Runs',
    nBallFaced: 'Balls',
    sStrikeRate: 'SR',
    nFours: '4s',
    nSixes: '6s'
  })
  const playingXIMember: any = useRef()
  let res = []
  const [result, setResult] = useState<any>()
  const [capwk, setCapWk] = useState()
  playingXIMember.current = fullSquad.filter(data => data.bPlaying11 === true)
  const team1PlayingPlayerData = playingXIMember.current.filter(
    (item: any) => item.oTeam._id === data?.iBattingTeamId
  )
  const team2PlayingPlayerData = playingXIMember.current.filter(
    (item: any) => item.oTeam._id !== data?.iBattingTeamId
  )
  const filterForYetToBat = (arr1: any, arr2: any) => {
    res = arr1.filter((el: any) => {
      return !arr2.aBatters.find((element: any) => {
        return element?.iBatterId === el.iPlayerId
      })
    })
    setResult(res)
  }

  const filterForCapWk = (arr1: any, arr2: any) => {
    res = arr1.filter((el: any) => {
      return arr2.aBatters.find((element: any) => {
        if (
          el.iPlayerId === element?.iBatterId &&
          (el.sRoleStr === 'cap' || el.sRoleStr === 'wk' || el.sRoleStr === 'wkcap')
        ) {
          return el
        } else {
          return null
        }
      })
    })
    setCapWk(res)
  }

  useEffect(() => {
    if (data?.iBattingTeamId === team1PlayingPlayerData[0]?.oTeam?._id) {
      filterForYetToBat(team1PlayingPlayerData, data)
    } else {
      filterForYetToBat(team2PlayingPlayerData, data)
    }
  }, [])

  function getPlayersByRole(players: any, role: any) {
    let firstPlayer
    const otherPlayers = []

    for (const player of players) {
      if (player.sRoleStr === role) {
        firstPlayer = player
      } else {
        otherPlayers.push(player)
      }
    }

    return [firstPlayer, ...otherPlayers]
  }

  useEffect(() => {
    if (data?.iBattingTeamId === team1PlayingPlayerData[0]?.oTeam?._id) {
      filterForCapWk(team1PlayingPlayerData, data)
    } else {
      filterForCapWk(team2PlayingPlayerData, data)
    }
  }, [])

  const playersByRole = result?.length ? getPlayersByRole(result, 'bat') : []
  const totalSix = data?.aBatters?.reduce((acc: any, batter: any) => acc + batter?.nSixes, 0) || 0
  const totalFours = data?.aBatters?.reduce((acc: any, batter: any) => acc + batter?.nFours, 0) || 0

  return (
    <div className={`mb-6 md:mx-0`}>
      <ThemeTable labels={labels} className="!rounded-none md:!rounded-xl" isBordered={true}>
        {data?.aBatters?.map((batter: any, index: number) => {
          return (
            <BatterDataRow
              isMatchCompleted={sStatusStr === 'completed'}
              key={index}
              batter={batter}
              table={table}
              capwk={capwk}
              setExpendId={setExpendId}
              expendId={expendId}
            />
          )
        })}
        <tr>
          <td className="font-bold max-w-16">
            <span className="flex flex-col justify-end  md:flex-row">
              <span className={`w-24 text-t-light mr-6 font-bold`}>Total</span>
              {/* <span className={``}>
								{data?.oEquations?.sRunRate} Runs per over
							</span> */}
            </span>
          </td>
          <td className="max-w-10 align-top">
            {data?.oEquations?.nRuns}
            {/* {data?.oEquations?.sOvers &&
							data?.oEquations?.nWickets >= 0 &&
							` (${data?.oEquations?.nWickets} Wkts, ${data?.oEquations?.sOvers} Ov)`} */}
          </td>
          <td className="!text-right">-</td>
          <td className="!text-right">-</td>
          <td>{totalFours}</td>
          <td>{totalSix}</td>
        </tr>
        <tr>
          {result?.length > 0 && (
            <td colSpan={6} className={`!text-left`}>
              {sStatusStr === 'completed' ? (
                <span className={`w-24 inline-block text-t-light font-bold mr-6 align-top`}>
                  Did not bat:{' '}
                </span>
              ) : (
                <span className={`w-24 inline-block text-t-light font-bold mr-6 align-top`}>
                  Yet To Bat:{' '}
                </span>
              )}
              <span className={`whitespace-pre-wrap inline`}>
                {result?.length > 0
                  ? playersByRole?.map((ytb, index) => (
                      <span key={index}>
                        {ytb?.sName}
                        {ytb?.sRoleStr === 'wk' && '(Wk)'}
                        {ytb?.sRoleStr === 'cap' && '(c)'}
                        {ytb?.sRoleStr === 'wkcap' && '(c & wk)'}
                        {playersByRole.length - 1 === index || !ytb?.sName ? '' : ', '}
                      </span>
                    ))
                  : ' - '}
              </span>
            </td>
          )}
        </tr>
        <tr>
          <td className="font-bold max-w-16">
            <span className="flex flex-col md:flex-row">
              <span className={`w-24 text-textOffWhite mr-6 font-medium`}>Extras</span>
              <span className={`text-uppercase text-textDselected font-medium`}>
                b - {data?.oExtraRuns?.nByes}, w - {data?.oExtraRuns?.nWides}, no -{' '}
                {data?.oExtraRuns?.nNoBalls}, lb - {data?.oExtraRuns?.nLegByes}, p -{' '}
                {data?.oExtraRuns?.nPenalty === null ? '0' : data?.oExtraRuns?.nPenalty}
              </span>
            </span>
          </td>
          <td className="align-top">{data?.oExtraRuns?.nTotal}</td>
          <td colSpan={4}> </td>
        </tr>
      </ThemeTable>
    </div>
  )
}

export default ScorecardTable
